__turbopack_context__.v({
  "container": "_5UaPBq_container",
  "number": "_5UaPBq_number",
  "operator": "_5UaPBq_operator",
});
